<m-form
  :form-group="formGroup"
  class="m-u--margin-top fiche-repondant-form"
>
  <div class="fiche-repondant-form--row">
    <div class="fiche-repondant-form--column">
      <h5>
        {{ $i18next.t('modules.fiche-repondant.form.FicheRepondantForm.label.repondant') }}
      </h5>
      <hr />
    </div>
  </div>
  <div class="fiche-repondant-form--row">
    <div class="fiche-repondant-form--column-half fiche-repondant-form--column-half-left">
      <m-textfield
        v-model="prenomField.value"
        v-m-control="prenomField"
        :label="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.prenom.label')"
        max-width="none"
        :error="prenomField.hasError()"
        :error-message="prenomField.errorMessage"
        :requiredMarker="true"
      />
    </div>
    <div class="fiche-repondant-form--column-half fiche-repondant-form--column-half-right">
      <m-textfield
        v-model="nomField.value"
        v-m-control="nomField"
        :label="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.nom.label')"
        max-width="none"
        :error="nomField.hasError()"
        :error-message="nomField.errorMessage"
        :requiredMarker="true"
      />
    </div>
  </div>
  <div class="fiche-repondant-form--row">
    <div class="fiche-repondant-form--column-half fiche-repondant-form--column-half-left">
      <m-textfield
        v-model="fonctionField.value"
        v-m-control="fonctionField"
        :label="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.fonction.label')"
        max-width="none"
        :error="fonctionField.hasError()"
        :error-message="fonctionField.errorMessage"
        :requiredMarker="true"
      />
    </div>
    <div class="fiche-repondant-form--column-half fiche-repondant-form--column-half-right">
      <m-dropdown
        :label="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.langue.label')"
        :placeholder="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.langue.placeholder')"
        :filterable="true"
        v-model="langueDropdown.value"
        v-m-control="langueDropdown"
        :error="langueDropdown.hasError()"
        :error-message="langueDropdown.errorMessage"
        max-width="none"
        :requiredMarker="true"
      >
        <template v-for="langue in FICHE_REPONDANT_LANGUE">
          <m-dropdown-item
            :key="langue"
            :label="$i18next.t(`modules.fiche-repondant.form.FicheRepondantForm.field.langue.value.${langue}`)"
            :value="langue"
          />
        </template>
      </m-dropdown>
    </div>
  </div>
  <div class="fiche-repondant-form--row">
    <div class="fiche-repondant-form--column-half fiche-repondant-form--column-half-left">
      <m-textfield
        v-model="telephoneField.value"
        v-m-control="telephoneField"
        :label="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.telephone.label')"
        max-width="none"
        :error="telephoneField.hasError()"
        :error-message="telephoneField.errorMessage"
      />
    </div>
    <div class="fiche-repondant-form--column-half fiche-repondant-form--column-half-right">
      <m-textfield
        v-model="courrielField.value"
        v-m-control="courrielField"
        :label="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.courriel.label')"
        max-width="none"
        :error="courrielField.hasError()"
        :error-message="courrielField.errorMessage"
        :requiredMarker="true"
        :type="MTextfieldType.Email"
      />
    </div>
  </div>
  <div class="fiche-repondant-form--row">
    <div class="fiche-repondant-form--column-half fiche-repondant-form--column-half-left">
      <m-textfield
        v-model="villeField.value"
        v-m-control="villeField"
        :label="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.ville.label')"
        max-width="none"
        :error="villeField.hasError()"
        :error-message="villeField.errorMessage"
        :requiredMarker="true"
      />
    </div>
    <div class="fiche-repondant-form--column-half fiche-repondant-form--column-half-right">
      <m-dropdown
        :label="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.country.label')"
        :placeholder="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.country.placeholder')"
        :filterable="true"
        v-model="countryDropdown.value"
        v-m-control="countryDropdown"
        :error="countryDropdown.hasError()"
        :error-message="countryDropdown.errorMessage"
        max-width="none"
        :requiredMarker="true"
      >
        <template v-for="country in countries">
          <m-dropdown-item
            :key="country.id"
            :label="country.nom"
            :value="country.id"
          />
        </template>
      </m-dropdown>
    </div>
  </div>
  <div class="fiche-repondant-form--row fiche-repondant-form__section-employeur">
    <div class="fiche-repondant-form--column">
      <h5>
        {{ $i18next.t('modules.fiche-repondant.form.FicheRepondantForm.label.employeur') }}
      </h5>
      <hr />
    </div>
  </div>
  <div class="fiche-repondant-form--row">
    <div class="fiche-repondant-form--column">
      <m-textfield
        v-model="employeurNomField.value"
        v-m-control="employeurNomField"
        :label="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.employeur_nom.label')"
        max-width="none"
        :error="employeurNomField.hasError()"
        :error-message="employeurNomField.errorMessage"
        :requiredMarker="true"
      />
    </div>
  </div>
  <div class="fiche-repondant-form--row">
    <div class="fiche-repondant-form--column">
      <m-textfield
        v-model="employeurAdresseField.value"
        v-m-control="employeurAdresseField"
        :label="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.employeur_adresse.label')"
        max-width="none"
        :error="employeurAdresseField.hasError()"
        :error-message="employeurAdresseField.errorMessage"
      />
    </div>
  </div>
  <div class="fiche-repondant-form--row fiche-repondant-form__section-preuve">
    <div class="fiche-repondant-form--column">
      <h5>
        {{ $i18next.t('modules.fiche-repondant.form.FicheRepondantForm.label.preuve') }}
      </h5>
      <hr />
      <m-message :state="MMessageState.Information">
        <span v-html="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.message.information')" />
      </m-message>
    </div>
  </div>
  <div class="fiche-repondant-form--row">
    <div class="fiche-repondant-form--column">
      <m-textfield
        v-model="employeurPreuveUrlField.value"
        v-m-control="employeurPreuveUrlField"
        :label="$i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.employeur_preuve_url.label')"
        max-width="none"
        :error="employeurPreuveUrlField.hasError()"
        :error-message="employeurPreuveUrlField.errorMessage"
      />
    </div>
  </div>

  <div class="fiche-repondant-form--row fiche-repondant-form__section-preuve--wrapper">
    <div class="fiche-repondant-form--column fiche-repondant-form__section-preuve--fichier-upload">
      <m-file-upload
        :allowedExtensions="ALLOWED_ATTACHMENT_EXTENSIONS"
        @files-ready="onFilesReady"
        @done="onFilesUploadCompleted"
      >
        <m-add>
          {{ $i18next.t('modules.fiche-repondant.form.FicheRepondantForm.field.file_upload.trigger') }}
        </m-add>
      </m-file-upload>
    </div>
    <div class="fiche-repondant-form--column fiche-repondant-form__section-preuve--fichiers">
      <template v-for="fichierPreuve, index in fichiersPreuve">
        <uploaded-file-row
          :uploaded-file="fichierPreuve"
          :display-divider="index < fichiersPreuve.length - 1"
          @delete="removePreuveFicher(index)"
        />
      </template>
    </div>
  </div>
</m-form>